<template>
    <q-card class="c-ToolPanel_1 q-mx-none q-pa-none" style="width: 100%; display: flex; flex-direction: row; max-width: 750px; background-color: white;" v-if="isvisible" flat>
        <q-card class="q-mx-none q-pa-none" style="overflow: auto; width: 100%; flex-grow: 1; display: flex; flex-direction: column; background-color: white;" flat>
            <div class="q-px-sm q-py-xs q-mt-none consistentText" style="width: 100%;">
                <div class="row items-center no-wrap q-mb-xs">
                    {{ Translate('Constrain the source data by the field values you choose.') }}
                    <q-space />
                    <q-toggle dense color="primary" :label="Translate('Advanced settings')" class="q-ma-none col-auto" v-model="advancedSettings" />
                </div>
            </div>

            <q-input outlined dense hide-bottom-space clearable :label="Translate('Search')" v-model="search" class="q-mb-md" bg-color="white">
                <template v-slot:prepend>
                    <q-icon name="mdi-magnify" />
                </template>
            </q-input>

            <div v-show="!search && isMetricsSectionVisible">
                <q-banner v-if="showwarn" dense class="text-white q-mb-sm" style="background-color: var(--v-outbound-base, #e07a1a)">
                    <template #avatar>
                        <q-icon name="mdi-alert" color="white" class="q-mr-md" />
                    </template>
                    {{ Translate('Filtering displayed metrics may hide rows in the grid, but totals will still reflect all data. Filtering on non-displayed metrics, both the grid and totals will adjust to reflect filtered content.') }}
                </q-banner>

                <div class="q-px-sm q-py-xs" style="border-bottom: 2px solid var(--v-lightGreyBorder-base); color: #9d9d9d;">
                    {{ Translate('METRICS') }}
                </div>

                <FilterCategory :columns="metricColumns"
                                :column_filters="column_filters"
                                :initial_column_filters="initial_column_filters"
                                :settings="settings"
                                :ReadOnly="ReadOnly"
                                :advancedSettings="advancedSettings"
                                :getColumnComponent="getColumnComponent"
                                :getFilterValue="getFilterValue"
                                :updateFilterValue="updateFilterValue"
                                :EventBus="EventBus"></FilterCategory>
            </div>

            <div v-show="!search" v-for="(cat,k) in filterCategoriesList" :key="k">
                <div class="q-px-sm q-py-xs consistentText" v-if="isCategoryVisible(cat)" style="border-bottom: 2px solid var(--v-lightGreyBorder-base);">{{ Translate(filterCategoryPrefix(cat)).toUpperCase() }}</div>

                <q-list v-if="isCategoryVisible(cat)">

                    <FilterCategory :columns="getColumnsByCategory(cat)"
                                    :column_filters="column_filters"
                                    :initial_column_filters="initial_column_filters"
                                    :settings="settings"
                                    :ReadOnly="ReadOnly"
                                    :advancedSettings="advancedSettings"
                                    :getColumnComponent="getColumnComponent"
                                    :getFilterValue="getFilterValue"
                                    :updateFilterValue="updateFilterValue"
                                    :EventBus="EventBus"></FilterCategory>

                </q-list>
            </div>

            <div v-if="search">
                <div class="q-px-sm q-py-xs consistentText" style="border-bottom: 2px solid var(--v-lightGreyBorder-base);">
                    {{ Translate('SEARCH RESULTS') }}
                </div>

                <FilterCategory :columns="columnsFromSearch"
                                :column_filters="column_filters"
                                :initial_column_filters="initial_column_filters"
                                :settings="settings"
                                :ReadOnly="ReadOnly"
                                :advancedSettings="advancedSettings"
                                :getColumnComponent="getColumnComponent"
                                :getFilterValue="getFilterValue"
                                :updateFilterValue="updateFilterValue"
                                :EventBus="EventBus"></FilterCategory>
            </div>

            <div style="justify-content: unset; border-top: 1px solid var(--v-lightGreyBorder-base);" class="q-mt-xs">
                <q-btn v-if="!ReadOnly" flat no-caps color="primary" class="q-px-none customHoverButton q-mt-xs c-SentenceCaseButton"
                       @click="addFilter">
                    <q-icon name="mdi-plus" size="sm" class="q-mr-xs" />
                    <span>{{ Translate('Add Filter') }}</span>
                </q-btn>
            </div>
            <!--<div>
                <q-btn v-if="!ReadOnly" elevation="0" class="q-px-none customHoverButton" @click="addFilter">
                    <q-icon left class="q-mr-xs">
                        mdi-plus
                    </q-icon>
                    Add Filter
                </q-btn>
            </div>-->
        </q-card>

        <q-dialog v-model="addFilterVisible" persistent>
            <q-card style="width: 590px; max-width: 590px">
                <q-card-section class="text-h6 row items-center no-wrap">
                    {{ Translate('Select filters') }}
                    <q-space></q-space>
                    <q-btn flat round dense icon="mdi-close" @click="addFilterVisible = false" />
                </q-card-section>

                <q-card-section>
                    <q-input ref="search_dlg_field"
                             style="cursor: default !important;"
                             outlined
                             dense
                             clearable
                             :placeholder="Translate('Search')"
                             prepend-inner-icon="mdi-magnify"
                             v-model="search_dlg"
                             @click="openSelectFiltersMenu"
                             @keydown="openSelectFiltersMenu"
                             @update:model-value="onSearchDlgChanged"
                             @blur="onSearchDlgBlur">
                        <template v-slot:prepend>
                            <q-icon name="mdi-magnify" />
                        </template>
                        <template v-slot:append>
                            <q-icon name="mdi-menu-down" class="cursor-pointer" @mousedown.prevent @click.stop="toggleSelectFiltersMenu" />
                        </template>
                    </q-input>

                    <q-menu v-model="menuSelectFiltersOpen"
                            :target="getSearchDlgTarget()"
                            :no-parent-event="true"
                            anchor="bottom left"
                            self="top left"
                            :offset="[0, 2]"
                            fit
                            no-focus>
                        <q-list style="max-height: 320px; overflow-y: auto;" bordered>
                            <template v-if="filteredColumnsFromSearch_dlg.length > 0">
                                <template v-for="(item, index) in filteredColumnsFromSearch_dlg" :key="item.ColId">
                                    <template v-if="isCategoryHeader(index, item.Category)">
                                        <q-item-label header class="q-ml-sm q-pl-none">{{ Translate(item.Category).toUpperCase() }}</q-item-label>
                                        <q-separator></q-separator>
                                    </template>
                                    <q-item class="q-ml-sm"
                                            clickable
                                            :active="search_colid === item.ColId"
                                            :disable="item.disable"
                                            @mousedown.prevent
                                            @click="selectFilterDlg(item)">
                                        <q-item-section>
                                            {{ Translate(item.Title) }}
                                        </q-item-section>
                                    </q-item>
                                </template>
                            </template>
                            <q-item v-else>
                                <q-item-section>
                                    {{ Translate('No results found') }}
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-menu>
                </q-card-section>

                <q-card-actions>
                    <q-space></q-space>

                    <q-btn color="primary"
                           no-caps
                           unelevated
                           class="q-mb-sm q-mr-sm c-SentenceCaseButton"
                           :disabled="!search_colid || !search_dlg"
                           @click="addFilterResponse(search_colid)">
                        <span>{{ Translate('Select') }}</span>
                    </q-btn>
                </q-card-actions>
            </q-card>
        </q-dialog>
    </q-card>
</template>

<script>
    /* eslint-disable */

    import { nextTick } from "vue";
    import utils from '@/Shared/utils.jsx';
    import common from './common.js';

    import { appSettings } from '@/Shared/appSettings';

    import FilterCategory from './filterCategory.vue';
    import MetricTypeFilter from './metricTypeFilterPopup.vue';
    import methods from '@/Shared/methods';
import Enumerable from "linq";

    export default {
        components: {
            FilterCategory,
            MetricTypeFilter,
        },
        props: {
            EventBus: null,
            column_list: {
                type: Array
            },
            column_filters: {
                type: Object
            },
            initial_column_filters: null,
            ReadOnly: null,
            settings: null,
            report_settings: null,
            source: null,
            isvisible: null,
            debugMode: null,
        },
        data: function () {
            return {
                columnLookup: {},
                fieldChoices: [],
                filters: [],
                openpanels: [],
                categoryPanels: {},
                search: '',
                search_dlg: '',
                search_colid: '',
                menuSelectFiltersOpen: false,
                advancedSettings: false,

                filterDataTypes: [
                    { text: 'Counts', filter: 'type', types: ['countColumn', 'floatColumn'] },
                    { text: 'Dates / Times', filter: 'type', types: ['dateColumn', 'dateOnlyColumn', 'timeOnlyColumn'] },
                    { text: 'Durations', filter: 'type', types: ['durationColumn'] },
                    { text: 'Percents', filter: 'type', types: ['percentColumn'] },
                    { text: 'Text Values', filter: 'type', types: ['textSetColumn', 'searchableTextColumn', 'channelTypeColumn', 'directionColumn', 'userIDColumn', 'customerIDColumn', 'phoneNumColumn'] },
                    { text: 'True / False', filter: 'type', types: ['booleanColumn'] },
                ],
                filterCategories: [],
                filterSources: [],

                addFilterVisible: false,
                anyFilters: false,

                filterDataTypes_selection: [],
                filterCategory_selection: [],
                filterSources_selection: [],
            }
        },
        watch: {
            filterDataTypes_selection: function (newv) {
                this.saveFilterFilters();
            },
            filterCategory_selection: function (newv) {
                this.saveFilterFilters();
            },
            filterSources_selection: function (newv) {
                this.saveFilterFilters();
            },
            advancedSettings: function (newv) {
                appSettings.LocalStorage(this.storageKey + '-filterFilters-advancedSettings', newv ? 'true' : null);
            },
            //addFilterVisible: function (newv) {
            //    if (newv) {
            //        this.$nextTick(() => {
            //            this.$refs.search_dlg_field.focus();
            //        });
            //    }
            //},
        },
        created() {
            for (let cat of [...new Set(this.column_list.filter(a => a.ColumnUse.Filter).map(a => a.FilterCategory || a.Category))])
                this.categoryPanels[cat] = [];

            console.log('Report Filters, report_settings:');
            console.log(JSON.stringify(this.report_settings, null, 3));

            if (appSettings.LocalStorage(this.storageKey + '-filterFilters-advancedSettings') == 'true')
                this.advancedSettings = true;

            //------------------------ New --------------------//

            // Populate a distinct list of categories for metric filters
            this.filterCategories = [...new Set(this.column_list.filter(a => a.ColumnUse.Filter).map(a => a.FilterCategory || a.Category))]
                .filter(a => a)
                .toSorted((a, b) => common.byField(a, b))
                .map(a => ({ text: a.indexOf('#') <= 1 ? a.substr(a.indexOf('#') + 1) : a, filter: 'Category', category: a }));

            // Populate a distinct list of source names (contacts, users, etc)
            this.filterSources = [...new Set(this.column_list.filter(a => a.ColumnUse.Filter).flatMap(a => a.Sources))]
                .toSorted((a, b) => common.byField(common.sourceTypes[a], common.sourceTypes[b]))
                .map(a => ({ text: a, filter: 'Source', source: a }));

            this.loadFilterFilters();
        },
        mounted() {
            for (let c of this.column_list.filter(a => a.ColumnUse.Filter))
                this.columnLookup[c.ColId] = c;
        },
        computed: {
            filterCategoriesList: function () {
                if (this.ReadOnly)
                    return [...new Set(this.column_list.filter(a => a.ColumnUse.Filter && a.SourceType != 'dateColumn').map(a => a.FilterCategory || a.Category))]
                        .toSorted((a, b) => common.byField(a, b));
                else
                    return [...new Set(this.column_list.filter(a => a.ColumnUse.Filter).map(a => a.FilterCategory || a.Category))]
                        .toSorted((a, b) => common.byField(a, b));
            },

            chosenColumns: function() {
                return this.fieldChoices.map(a => this.columnLookup[a])
                    .toSorted((a, b) => common.byField(a, b, 'Title'));
            },
            filterColumns: function() {
                const cols = this.column_list.filter(a => a.ColumnUse.Filter);
                return cols.toSorted((a, b) => common.byField(a, b, 'Title'));
            },
            metricColumns: function() {
                // These are the fields that are generated by the report - not the source fields.
                // You can filter on either the source fields or the computed metric fields.
                if (!this.report_settings || !this.report_settings.metrics) {
                    console.log('Returning empty metricColumns');
                    return [];
                }

                console.log(`Returning metricColumns with ${this.report_settings.metrics.length} metric(s)`);
                let cols = this.report_settings.metrics.filter(item => item.colId && common.column_lookup[item.colId]?.MetricAggs.Type != 'placeholder').map(item => {
                    const coldef = common.column_lookup[item.colId];
                    const newtype = common.getAggregateColumnType(item.colId, item.function, coldef.SourceType);
                    return {
                        ColumnUse: { Filter: true },
                        ColId: `${item.colId}_${item.function}_agg`,
                        Title: common.formatHeader({ type: newtype, headerName: coldef.Title, aggFunc: item.function }),
                        SourceType: newtype,
                        Category: '0#Metrics',
                    };
                });

                if (this.ReadOnly)
                    cols = cols.filter(c => this.column_filters[c.ColId] && this.column_filters[c.ColId].usage);

                return cols.toSorted((a, b) => common.byField(a, b, 'Title'));
            },
            fieldChoicesText: function() {
                return JSON.stringify(this.fieldChoices);
            },
            columnsFromSearch: function() {
                const s = this.search ? this.search.toLowerCase() : '';
                const cols = this.column_list
                    .filter(a => a.ColumnUse.Filter && a.Title.toLowerCase().includes(s))
                    .concat(this.metricColumns.filter(a => a.Title.toLowerCase().includes(s)))
                    .toSorted((a, b) => common.byField(a, b, 'Title'));

                if (this.ReadOnly)
                    return cols.filter(a => a.ColId != 'datetime' && a.ColId != 'starttime')
                else
                    return cols;
            },
            columnsFromSearch_dlg: function () {
                let colslist = this.column_list
                    .filter(a => a.ColumnUse.Filter)
                    .map(a => ({
                        ColId: a.ColId,
                        Title: a.Title,
                        Category: this.filterCategoryPrefix(a.FilterCategory || a.Category),
                        isInUse: !!this.column_filters[a.ColId],
                        disable: !!this.column_filters[a.ColId]
                    }));

                let metricslist = this.metricColumns.map(a => ({
                    ColId: a.ColId,
                    Title: a.Title,
                    Category: this.filterCategoryPrefix(a.FilterCategory || a.Category),
                    isInUse: !!this.column_filters[a.ColId],
                    disable: !!this.column_filters[a.ColId]
                }));

                const all = metricslist.concat(colslist);
                const seen = new Set();
                const deduped = [];
                for (let item of all) {
                    if (!item || !item.ColId || seen.has(item.ColId))
                        continue;
                    seen.add(item.ColId);
                    deduped.push(item);
                }

                // Match Vue2: report metrics first, then Most Popular, then other categories A–Z.
                // (Vue2 concat'd metrics ahead of columns; a Most-Popular-only pin buried Metrics.)
                return deduped.toSorted((a, b) => {
                    const categoryRank = (cat) => {
                        if (cat === 'Metrics') return 0;
                        if (cat === 'Most Popular') return 1;
                        return 2;
                    };
                    const ra = categoryRank(a.Category);
                    const rb = categoryRank(b.Category);
                    if (ra !== rb)
                        return ra - rb;

                    let comp = a.Category.localeCompare(b.Category);
                    if (comp == 0)
                        comp = a.Title.localeCompare(b.Title);

                    return comp;
                });
            },
            filteredColumnsFromSearch_dlg: function () {
                const s = (this.search_dlg || '').toLowerCase();
                if (!s)
                    return this.columnsFromSearch_dlg;

                return this.columnsFromSearch_dlg.filter(a => a.Title.toLowerCase().includes(s) || a.Category.toLowerCase().includes(s));
            },
            showwarn: function () {
                return Object.keys(this.column_filters).some(a => a.includes('_agg'));
            },
            isMetricsSectionVisible: function () {
                // Vue2: show whenever the report has metrics selected (not only after a metric filter is applied)
                return this.metricColumns.length > 0;
            },
        },
        methods: {
            ...methods,
            loadFilterFilters() {
                for (let i = 0; i < this.filterDataTypes.length; i++)
                    if (appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterDataTypes[i].flat + '-' + (this.source ? `-${this.source}` : '')) != 'hidden')
                        this.filterDataTypes_selection.push(i);

                for (let i = 0; i < this.filterCategories.length; i++)
                    if (appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterCategories[i].flat + '-' + (this.source ? `-${this.source}` : '')) != 'hidden')
                        this.filterCategory_selection.push(i);

                if (this.debugMode) {
                    for (let i = 0; i < this.filterSources.length; i++)
                        if (appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterSources[i].flat + '-' + (this.source ? `-${this.source}` : '')) != 'hidden')
                            this.filterSources_selection.push(i);
                }
                else
                    this.filterSources_selection = this.filterSources.map((a, i) => i);

                this.anyFilters = 
                    this.filterDataTypes_selection.length < this.filterDataTypes.length ||
                    this.filterCategory_selection.length < this.filterCategories.length ||
                    this.filterSources_selection.length < this.filterSources.length;
            },
            saveFilterFilters() {
                for (let i = 0; i < this.filterDataTypes.length; i++)
                    appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterDataTypes[i].flat + '-' + (this.source ? `-${this.source}` : ''), this.filterDataTypes_selection.includes(i) ? null : 'hidden');

                for (let i = 0; i < this.filterCategories.length; i++)
                    appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterCategories[i].flat + '-' + (this.source ? `-${this.source}` : ''), this.filterCategory_selection.includes(i) ? null : 'hidden');

                if (this.filterSources)
                    for (let i = 0; i < this.filterSources.length; i++)
                        appSettings.LocalStorage(this.storageKey + '-filterFilters-type:' + this.filterSources[i].flat + '-' + (this.source ? `-${this.source}` : ''), this.filterSources_selection.includes(i) ? null : 'hidden');
            },
            isCategoryVisible(category) {
                const selected = this.filterCategory_selection.map(i => this.filterCategories[i].category);
                const visible = selected.some(a =>  a == category);

                // Return only the categories that have active filters
                const inuse = this.column_list.some(a => a.ColumnUse.Filter && (a.FilterCategory || a.Category) == category && this.column_filters[a.ColId]);

                return visible && inuse;
            },
            getColumnsByCategory(category) {
                const visibletypes = this.filterDataTypes_selection.flatMap(i => this.filterDataTypes[i].types);
                const visiblesources = this.filterSources_selection.map(i => this.filterSources[i].source);

                let res;
                if (this.ReadOnly)
                    res = this.column_list
                        .filter(a => a.SourceType != 'dateColumn' && a.ColumnUse.Filter && (a.FilterCategory || a.Category) == category && visibletypes.includes(a.SourceType) && a.Sources.some(s => visiblesources.includes(s)))
                        .toSorted((a, b) => common.byField(a, b, 'Title'));
                else
                    res = this.column_list
                        .filter(a => a.ColumnUse.Filter && (a.FilterCategory || a.Category) == category && visibletypes.includes(a.SourceType) && a.Sources.some(s => visiblesources.includes(s)))
                        .toSorted((a, b) => common.byField(a, b, 'Title'));

                return res;
            },
            getColumnComponent(item) {
                return `Filter${item.SourceType}`;
            },

            addFilterVisibleDlgState(state) {
                console.log(`addFilterVisibleDlgState(state:${state})`);
                if (state) {
                    this.$nextTick(() => {
                        this.$refs.search_dlg_field.focus();
                    });
                }
            },
            addFilter() {
                this.search_dlg = '';
                this.search_colid = '';
                this.menuSelectFiltersOpen = false;
                this.addFilterVisible = true;

                //this.$nextTick(() => {
                //    this.$refs.search_dlg_field.focus();
                //});
                setTimeout(() => {
                    const item = this.$refs.search_dlg_field;
                    if (item) {
                        item.focus();

                        let inputEl = item.$el.querySelector('input');
                        inputEl.select();

                        setTimeout(() => {
                            inputEl.select();
                        }, 200);
                    }
                }, 250);
            },
            addFilterResponse(colId) {
                this.addFilterVisible = false;
                this.column_filters[colId] = {
                    usage: 0,
                };
                this.$emit('filterschanged', this.column_filters, colId);

                const eventBus = this.EventBus;
                nextTick(() => {
                    eventBus.$emit('SetPanelOpenState', colId);
                });
                //this.EventBus.$emit('SetPanelOpenState', colId);
            },
            onSearchDlgChanged(value) {
                this.search_dlg = value || '';
                const selected = this.columnsFromSearch_dlg.find(a => a.ColId === this.search_colid);
                if (!selected || selected.Title !== this.search_dlg)
                    this.search_colid = '';
            },
            selectFilterDlg(item) {
                if (!item || item.disable)
                    return;

                this.search_dlg = item.Title;
                this.search_colid = item.ColId;
                this.menuSelectFiltersOpen = false;
            },
            openSelectFiltersMenu() {
                this.menuSelectFiltersOpen = true;
            },
            toggleSelectFiltersMenu() {
                this.menuSelectFiltersOpen = !this.menuSelectFiltersOpen;
            },
            onSearchDlgBlur() {
                setTimeout(() => {
                    this.menuSelectFiltersOpen = false;
                }, 120);
            },
            getSearchDlgTarget() {
                return this.$refs.search_dlg_field?.$el;
            },
            isCategoryHeader(index, category) {
                if (index <= 0)
                    return true;
                return this.filteredColumnsFromSearch_dlg[index - 1].Category !== category;
            },
            getFilterValue(col) {
                return this.column_filters[col.ColId];
            },
            updateFilterValue(col, value) {
                console.log("Inside updateFilterValue");
                console.log("col is " + JSON.stringify(col));
                console.log("value is " + JSON.stringify(value));
                              
                //Checking if filter is constrained to current user
                if (value && value["cleared"] == 1)
                {
                    var existingFilter = this.column_filters[col.ColId];
                    if (existingFilter && existingFilter["filter"] == "{{CurrentUserID}}")
                    {
                        //Denied attempt to clear filter constrained to current user
                        return;
                    }
                }

                // Sample data format for filterModel
                // { "callerid":    { "filterType": "text",   "type": "contains",    "filter": "5432"} }
                // { "contacttime": { "filterType": "number", "type": "greaterThan", "filter": 60 } }
                // { "answered":    { "filterType": "set",    "values": [ "true" ] } }

                if (value) {
                    this.column_filters[col.ColId] = value;
                } else {
                    delete this.column_filters[col.ColId];
                }

                //console.log('updating column_filters:');
                //console.log(JSON.stringify(this.column_filters,null,3));

                this.$emit('filterschanged', this.column_filters, col.ColId);
            },
            filterCategoryPrefix(cat) {
                if (!cat) return this.Translate('Unknown');
                const idx = cat.indexOf('#');
                return idx >= 0 && idx < 3 ? cat.substring(idx + 1) : cat;
            },
            includes(arr, value) {
                for(let i=0; i<arr.length; i++) {
                    const v = arr[i];
                    if (v === value)
                        return true;
                }

                return false;
            },
            isFieldOpen(col, index) {
                const cat = col.FilterCategory || col.Category;
                const open = this.includes(this.categoryPanels[cat], index);

                console.log(`-- -- -- isFieldOpen(col:${col.ColId}, index:${index}), cat:${cat}: ${open}`);

                return open;
            },
            setPanelState(cat, value) {
                console.log(`setPanelState(cat:${cat},value:${JSON.stringify(value)}); ${typeof value}`);

                const arr = this.categoryPanels[cat];
                arr.splice(0, arr.length);

                for(let i of value)
                    arr.push(i);

                console.log(`setPanelState(cat:${cat}) arr: ${JSON.stringify(arr)}; ${typeof value}`);
            },

            clearAllFilters() {
                alert('clearAllFilters in report filters');
            },
        }
    }
</script>

<style scoped>
    .columns-three {
        column-count: 3;
    }

    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

    p {
        font-size: 2em;
        text-align: center;
    }

    .metric_normal {

    }
    .metric_inuse {
        color: cornflowerblue;
    }
    .metric_usedup {
        color: silver;
    }
    .consistentText {
        color: var(--v-black-base) !important; 
        opacity: 0.8 !important; 
        font-size: 14px !important; 
        text-rendering: optimizelegibility !important; 
        letter-spacing:0.1 !important;
    }
    .customHoverButton:before {
        background-color: unset !important;
        transition: unset !important;
    }

    .customHoverButton {
        background-color: unset !important;
        color: var(--v-primary-base);
    }

        .customHoverButton:hover {
            filter: brightness(80%);
        }
</style>